export default "__VITE_ASSET__98574f36__"